import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import CreateAccountForm from "./components/CreateAccountForm";
import Payment from "./components/Payment.jsx";
import AboutPage from "./components/Seller/AboutPage";
import BillingHistory from "./components/Seller/BillingHistory.jsx";
import Deposit from "./components/Seller/Deposit";
import DirectSale from "./components/Seller/DirectSale";
import HomePage from "./components/Seller/HomePage.jsx";
import InvoiceDetail from "./components/Seller/InvoiceDetail.jsx";
import OgcsSale from "./components/Seller/OgcsSale";
import OrderDetails from "./components/Seller/OrderDetails.jsx";
import TrackingPage from "./components/Seller/orders.jsx";
import OrderTracking from "./components/Seller/OrderTracking.jsx";
import SellerPage from "./components/Seller/SellerPage.jsx";
import VisibilityDetailsPage from "./components/Seller/VisibilityDetailsPage";
import SignIn from "./components/SignIn.jsx";
import VerifyOtp from "./components/VerifyOtp.jsx";
import PowerPackVisibility from "./components/Seller/PowerPackVisibility.jsx";
import ProductHistory from "./components/Seller/ProductHistory.jsx";
import UpdateProfile from "./components/Seller/UpdateProfile.jsx";
import SignInForm from "./components/SignInForm.jsx";
import ReggenerateInvoice from "./utils/ReggenerateInvoice.js";
const NotFound = () => <h2>404 - Page Not Found</h2>;

function App() {
  return (
    <Router>
      <ToastContainer />
      <div className="bg-white">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/seller" element={<SellerPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/orders" element={<TrackingPage />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign" element={<SignInForm />} />
          <Route path="/create-account" element={<CreateAccountForm />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/direct-sale" element={<DirectSale />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route
            path="/visibility-details"
            element={<VisibilityDetailsPage />}
          />
          <Route path="/billing-history" element={<BillingHistory />} />
          <Route path="/invoice-detail" element={<InvoiceDetail />} />
          <Route path="/orders" element={<OrderTracking />} />
          <Route path="/powerpack" element={<PowerPackVisibility />} />
          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/sales-with-ogcs" element={<OgcsSale />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/Reggenerate-invoice" element={<ReggenerateInvoice />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/product-history" element={<ProductHistory />} />
          <Route path="/update-profile" element={<UpdateProfile />} />
          

        </Routes>
      </div>
    </Router>
  );
}

export default App;
